import { INITIAL_CATEGORY_STATE } from '@components';
import { useScrollToTop } from '@hooks';
import { useCategory } from '@hooks/category/category.hook';
import { Box, Pagination, styled } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';

// STYLES
//--------
const ProductListPaginationBox = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 16px 0;
  ${breakpoints.up('md')} {
    padding: 40px 0;
  }
`;

// TYPES
//-------

export type ProductListPaginationProps = {
  totalCount?: number;
};

// COMPONENTS
//------------
export const ProductListPagination = ({ totalCount = 0 }: ProductListPaginationProps) => {
  const scrollToTop = useScrollToTop();
  const { handlePaginationChange } = useCategory();
  const handleChange = (_: any, page: number) => {
    handlePaginationChange(page);
    scrollToTop();
  };
  const searchParams = new URLSearchParams(window.location.search);
  const currentPage = Number(searchParams.get('page')) || 1;
  const numberOfPages = Math.ceil((totalCount ?? 0) / INITIAL_CATEGORY_STATE.itemPerPage);

  if (numberOfPages < 2) {
    return null;
  }

  return (
    <ProductListPaginationBox>
      <Pagination
        page={currentPage}
        count={numberOfPages}
        variant='outlined'
        shape='rounded'
        onChange={handleChange}
        defaultPage={1}
      />
    </ProductListPaginationBox>
  );
};
